import React from 'react';
import styled from '@emotion/styled';
import _ from 'lodash';
import { useI18n } from '~Hooks';

const OuterWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background: #fff;
`;

const Wrapper = styled.div`
  display: flex;
  height: 540px;
  width: 1920px;
  flex-wrap: wrap;
  font-family: Oswald-Medium;
`;

const Column = styled.div`
  display: flex;
  width: 100%;
  height: 270px;
`;

const Order = styled.div<{
  ready?: boolean;
}>`
  box-sizing: border-box;
  flex: 0 0 200px;
  display: flex;
  color: ${(props) => (props.ready ? '#fff' : 'rgb(0, 107, 74)')};
  background: ${(props) => (props.ready ? '#006b4a' : 'transparent')};
  width: 200px;
  height: 100%;
  margin: 0;
  padding: 5px;
  justify-content: center;
  align-items: center;
`;

const OrderId = styled.div<{
  even?: boolean;
}>`
  transform: rotate(-90deg);
  font-size: 90px;
`;

const Title = styled.div`
  color: rgb(0, 107, 74);
  transform: rotate(-90deg);
  font-size: 40px;
  width: 130px;
  position: relative;
  left: 107px;
`;

const SecondTitle = styled.div`
  color: rgb(0, 107, 74);
  transform: rotate(-90deg);
  font-size: 40px;
  width: 130px;
  position: relative;
  top: 20px;
  left: 107px;
`;

interface IOrder {
  id: string;
  easyId: string;
}

interface Props {
  loading: boolean;
  cooking: IOrder[];
  ready: IOrder[];
  toggleMenu: () => void;
}

const CustomerDisplayView: React.FunctionComponent<Props> = ({
  loading,
  cooking,
  ready,
  toggleMenu,
}) => {
  const { i18n } = useI18n();

  if (loading) {
    return <div>{i18n('App.Loading')}</div>;
  }

  // Remove all duplicates
  const currentCooking = cooking.filter(
    (r, index, array) => array.findIndex((value) => value.easyId === r.easyId) === index,
  );

  const currentReady = ready.filter((r, index, array) => {
    const hasMultiple = currentCooking.findIndex((value) => value.easyId === r.easyId);
    const duplicate = array.findIndex((value) => value.easyId === r.easyId) === index;

    return hasMultiple == -1 || !duplicate;
  });

  return (
    <OuterWrapper>
      <Wrapper onClick={toggleMenu}>
        <Column>
          <Title>{_.toUpper(i18n('CustomerDisplay.Ready'))}</Title>
          {currentReady.map((order, i) => (
            <Order key={order.id} ready>
              <OrderId>{order.easyId}</OrderId>
            </Order>
          ))}
        </Column>
        <Column>
          <SecondTitle>{_.toUpper(i18n('CustomerDisplay.Preparing'))}</SecondTitle>
          {currentCooking.map((order, i) => (
            <Order key={order.id}>
              <OrderId even>{order.easyId}</OrderId>
            </Order>
          ))}
        </Column>
      </Wrapper>
    </OuterWrapper>
  );
};

export default CustomerDisplayView;
